module.exports = __webpack_public_path__ + "static/media/instagram-white.6cee8344.svg";